"use client";

import { useEffect, useState } from "react";

/**
 * Use with caution!
 */
export function useClient() {
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	return { isClient };
}
